import { Controller } from "@hotwired/stimulus"
import { lockScroll, unlockScroll } from "../utils/scroll_lock"

export default class extends Controller {
  static targets = ["modal", "iframe"]

  connect() {
    // Close modal when clicking outside
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)

    // Close modal on escape key
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.boundClickOutside)
    document.removeEventListener('keydown', this.boundKeydown)
  }

  open(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    
    const modal = this.modalTarget
    const iframe = this.iframeTarget
    
    if (modal && iframe) {
      // Get video URL from data attribute on the controller element
      const videoUrl = this.element.dataset.videoUrl
      
      if (videoUrl) {
        // Extract YouTube video ID and create embed URL
        const videoId = this.extractYouTubeId(videoUrl)
        if (videoId) {
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`
        } else {
          // Fallback: try to use URL directly (for Vimeo or other platforms)
          iframe.src = videoUrl
        }
      }
      
      modal.classList.remove('hidden')
      lockScroll()

      // Focus management
      const closeButton = modal.querySelector('button[data-action*="close"]')
      if (closeButton) {
        setTimeout(() => closeButton.focus(), 100)
      }
    }
  }

  close() {
    const modal = this.modalTarget
    const iframe = this.iframeTarget
    
    if (modal) {
      modal.classList.add('hidden')
      unlockScroll()
      
      // Stop video playback by clearing src
      if (iframe) {
        iframe.src = ''
      }
    }
  }

  handleClickOutside(event) {
    // Close modal if clicking on the backdrop (the fixed overlay)
    if (event.target.classList.contains('fixed') && event.target.classList.contains('inset-0')) {
      this.close()
    }
  }

  handleKeydown(event) {
    // Close modal on escape key
    if (event.key === 'Escape' && !this.modalTarget.classList.contains('hidden')) {
      this.close()
    }
  }

  extractYouTubeId(url) {
    if (!url) return null
    
    const patterns = [
      /youtube\.com\/shorts\/([^&\n?#]+)/,  // YouTube Shorts: youtube.com/shorts/VIDEO_ID
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/v\/([^&\n?#]+)/,
      /youtube\.com\/.*[?&]v=([^&\n?#]+)/
    ]
    
    for (const pattern of patterns) {
      const match = url.match(pattern)
      if (match) return match[1]
    }
    
    return null
  }
}

